import { IGenericSelectDataModel } from "@kuika/kuika-cl-model";
import classNames from "classnames";
import * as React from "react";
import GenericActionEmptyStateSvg from "../../../../../svgs/generic-action-empty-state.svg";
import KuikaH5 from "../../../../ui-kit/typography/H5/H5";
import KuikaTitle from "../../../../ui-kit/typography/Title/Title";

export interface IJoinTableEmptyState {}

export interface IJoinTableEmptyProps {
  isModal?: boolean;
  tablesLength: number;
  setDropdownVisibility: (val: boolean) => void;
  handleAddJoinClick?: (tableName: string, tableSchema: string) => void;
  selectData: IGenericSelectDataModel;
}

class JoinTableEmpty extends React.PureComponent<IJoinTableEmptyProps, IJoinTableEmptyState> {
  constructor(props: IJoinTableEmptyProps) {
    super(props);
    this.state = {};
  }

  render() {
    const { tablesLength } = this.props;

    const isStep1Active = tablesLength === 0;
    const isStep2Active = tablesLength === 1;

    return (
      <div className="join-table-empty">
        <GenericActionEmptyStateSvg aria-label="AI" />

        <div className="join-table-empty__card">
          {/* Step 1: Add a Data Table */}
          <div
            className={classNames("join-table-empty__step", {
              "join-table-empty__step--active": isStep1Active
            })}
            onClick={() => {
              if (isStep1Active) {
                this.props.setDropdownVisibility(true);
              }
            }}
          >
            <KuikaH5
              className={classNames("join-table-empty__title", {
                "join-table-empty__title--active": isStep1Active
              })}
            >
              1. Add a Data Table
            </KuikaH5>
          </div>

          {/* Step 2: Join Tables */}
          <div
            className={classNames("join-table-empty__step", {
              "join-table-empty__step--active": isStep2Active
            })}
            onClick={() => {
              if (isStep2Active && this.props.handleAddJoinClick && this.props.selectData.tables.length > 0) {
                const firstTable = this.props.selectData.tables[0];
                this.props.handleAddJoinClick(firstTable.name, firstTable.schema);
              }
            }}
          >
            <KuikaH5
              className={classNames("join-table-empty__title", {
                "join-table-empty__title--active": isStep2Active
              })}
            >
              2. Join Tables
            </KuikaH5>
            <KuikaTitle className={classNames("join-table-empty__description")}>
              Select a table to create a Select SQL query. Then link the related tables together.
            </KuikaTitle>
          </div>
        </div>
      </div>
    );
  }
}

export const JoinTableEmptyComponent = JoinTableEmpty;
